export default {
  "url-failed": {
    EN: "Failed to get subscription details. Please try again later.",
  },
};
